import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiListDataService } from './api.list-data.service';
import { ClientModel } from '../../models';
import { catchError, Observable } from 'rxjs';
import { ClientUsersModel } from 'core/models/new-client-card.model';
import { ClientDynamicData } from 'core/models/client-dynamic-data.model';

@Injectable({
    providedIn: 'root',
})
export class ApiClientService extends ApiListDataService<ClientModel, ClientModel> {
    constructor(http: HttpClient) {
        super(http, '/Client/');
    }

    public getClientUsers(
        id: number,
        recipientOrganizationId: number | undefined,
    ): Observable<ClientUsersModel[]> {
        return this.get(
            `${id}/ClientUser${
                recipientOrganizationId ? `?recipientOrganizationId=${recipientOrganizationId}` : ''
            }`,
        );
    }

    public getClientDynamicData(
        id: number,
        recipientOrganizationId: number | undefined,
    ): Observable<ClientDynamicData[]> {
        return this.get(
            `${id}/ClientDynamicData${
                recipientOrganizationId ? `?recipientOrganizationId=${recipientOrganizationId}` : ''
            }`,
        );
    }

    public getClientPreventionDynamicData(
        id: number,
        recipientOrganizationId: number | undefined,
    ): Observable<ClientDynamicData[]> {
        return this.get(
            `${id}/ClientPreventionDynamicData${
                recipientOrganizationId ? `?recipientOrganizationId=${recipientOrganizationId}` : ''
            }`,
        );
    }

    public download(id: number): Observable<any> {
        const requestOptions: object = {
            responseType: 'blob',
            observe: 'response',
        };

        return this.http
            .get(`${this.fullUrl('')}${id}/Export`, requestOptions)
            .pipe(catchError(this.formatErrors));
    }
}
